module.exports = __webpack_public_path__ + "static/media/tit.381b2777.png";